import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true })
export default class Dashboards extends VuexModule {
  _dashboardList: Dashboard[] = [];

  get dashboardList(): Dashboard[] {
    return this._dashboardList;
  }

  @Mutation
  SET_DASHBOARD_LIST(dashboardList: Dashboard[]) {
    this._dashboardList = dashboardList;
  }

  @Action
  async CREATE_DASHBOARD(payload: {kuzzle: any; tenantIndex: string; selectedAssets: []; dashboardName: string }) {
    try {
      const response = await payload.kuzzle.document.create(
        payload.tenantIndex,
        'dashboards',
        {
          assetIds: payload.selectedAssets,
          name: payload.dashboardName
        },
        null,
        { refresh: 'wait_for' }
      );
      return response._id;
    } catch (error) {
      throw error;
    }
  }

  @Action
  async SAVE_DASHBOARD(payload: {kuzzle: any; tenantIndex: string; selectedAssets: []; dashboardName: string; dashboardId: string }) {
    const response = await payload.kuzzle.document.replace(
      payload.tenantIndex,
      'dashboards',
      payload.dashboardId,
      {
        assetIds: payload.selectedAssets,
        name: payload.dashboardName
      },
      { refresh: 'wait_for' }
    );
    return response._id;
  }

  @Action    
  async FETCH_DASHBOARDS(payload: {kuzzle: any; tenantIndex: string}) {
    const dashboardList: Dashboard[] = [];

    try {
      const response = await payload.kuzzle.document.search(
        payload.tenantIndex,
        'dashboards',
        null,
        { size: 100}
      );
      for (const dashboard of response.hits) {
        dashboardList.push({
          name: dashboard._source.name,
          url: `/dashboard/${dashboard._id}`,
          icon: 'fas fa-chart-line'
        })
      }
      this.context.commit('SET_DASHBOARD_LIST', dashboardList);
    } catch (error) {
      throw error;
    }
  }

  @Action
  async DELETE_DASHBOARD(payload: {kuzzle: any; tenantIndex: string; dashboardId: string}) {
    try {
      await payload.kuzzle.document.delete(
        payload.tenantIndex,
        'dashboards',
        payload.dashboardId,
        { refresh: 'wait_for' }
      );
      await this.context.dispatch('FETCH_DASHBOARDS', {kuzzle: payload.kuzzle, tenantIndex: payload.tenantIndex});
    } catch (error) {
      throw error;
    }
  }
}

interface Dashboard {
  name: string;
  url: string;
  icon: string;
}
